var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter logo",
    clipPath: "url(#clip0_1086_311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9998 1.7049C17.3258 1.98937 16.6108 2.1761 15.8788 2.25887C16.6413 1.82346 17.2268 1.13398 17.5025 0.312468C16.7776 0.722276 15.9845 1.01101 15.1575 1.1662C14.4838 0.482477 13.5241 0.0551758 12.4619 0.0551758C10.4224 0.0551758 8.76891 1.63041 8.76891 3.57326C8.76891 3.84904 8.80161 4.11752 8.86454 4.37508C5.79539 4.22831 3.0743 2.82771 1.25286 0.699175C0.935043 1.21878 0.752934 1.82319 0.752934 2.46786C0.752934 3.68848 1.40494 4.76527 2.39579 5.39621C1.80934 5.37871 1.2358 5.22781 0.723051 4.95611C0.72284 4.97085 0.72284 4.98559 0.72284 5.00039C0.72284 6.70497 1.99578 8.12694 3.68511 8.45015C3.1413 8.59105 2.57088 8.61167 2.01743 8.51044C2.48733 9.90816 3.85118 10.9253 5.46711 10.9537C4.20324 11.8973 2.61087 12.4598 0.880762 12.4598C0.582637 12.4598 0.288731 12.4431 -0.000183105 12.4106C1.63409 13.4088 3.57521 13.9913 5.66068 13.9913C12.4534 13.9913 16.1678 8.63034 16.1678 3.98127C16.1678 3.82868 16.1642 3.67695 16.1571 3.5261C16.88 3.02819 17.5041 2.41147 17.9998 1.7049Z",
    fill: "#00058B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1086_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterlogo);
export default __webpack_public_path__ + "static/media/Twitter logo.f268fb8d1549f033ebd79ec082466e7d.svg";
export { ForwardRef as ReactComponent };